import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, CanActivateFn } from '@angular/router';
import { AuthService } from './auth.service';
import { PermissionRolesMap } from '@models/permissions.db';
import { Permissions } from '@models/permissions.enum';
import { ToastrService } from 'ngx-toastr';

export const roleGuard: CanActivateFn = (route: ActivatedRouteSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const toastr = inject(ToastrService);
  const permission = route.data?.['permission'] as Permissions | undefined;
  const userRoles = authService.roles;
  // Fail closed (UNIVAPLAT-3242): a route with no declared permission, or one that is not in
  // PermissionRolesMap, grants nobody access.
  const requiredRoles = permission ? PermissionRolesMap[permission] : undefined;

  if (authService.getToken() && requiredRoles && requiredRoles.some(role => userRoles.includes(role))) {
    return true;
  }

  const page = route?.url?.length ? (': ' + route.url[0].path) : '';
  router.navigate(['/']);
  toastr.warning(`You do not have permission to access this page${page}`, ' ');

  return false;
};
